var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"h-[32px] min-w-[32px] rounded-[10px] flex items-center justify-center focus:outline-none focus:ring-[2px] focus:ring-[#E5E5E5] focus:ring-offset-[1px] transition-colors duration-[150ms] cursor-pointer",class:{
    'shadow-[0px_1px_2px_0px_#0000001A] px-[16px] py-[8px] text-[14px]': _vm.type === 'default',
    'px-[16px] py-[8px] text-[14px]': _vm.type === 'ghost',
    'p-0': _vm.type === 'icon',
    'border-[1px] border-[#E5E5E5]': _vm.outline,
    'opacity-40 cursor-not-allowed pointer-events-none': _vm.disabled,
    'bg-[#F95E16] text-[#FFFFFF] hover:bg-[#E05510]': _vm.variant === 'primary',
    'border-[1px] border-[#F95E16] text-[#F95E16] bg-white hover:bg-[#FFF0E9]': _vm.variant === 'outline-primary',
    'border-[1px] border-[#E5E5E5] text-[#828282] bg-white hover:bg-[#F5F5F5]': _vm.variant === 'outline-secondary',
    'hover:bg-[#F5F5F5] hover:border-[#D0D0D0]': _vm.variant === 'default',
    'text-[#F95E16]': _vm.textColor === 'primary',
    'text-[#0A0A0A]': _vm.textColor === 'default',
  },attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }